import { ImageUploadClient } from '@spotify/confidence-backstage-image-upload';

import { ConfidenceUserApi } from './UserApi';
import {
  requestSignedUpload,
  uploadFileToSignedUri,
} from './imageUpload.helpers';

/**
 * Implementation of the ImageUpload API that uses the Confidence API to
 * store images.
 *
 * It depends on the Confidence User API to get the access token to make
 * the request to the Confidence API.
 */
export class ConfidenceImageUploadClient implements ImageUploadClient {
  private readonly userApi: ConfidenceUserApi;

  constructor(userApi: ConfidenceUserApi) {
    this.userApi = userApi;
  }

  async upload(file: File): Promise<string> {
    // get our access token
    const client = await this.userApi.getCredentials();
    const region =
      (await this.userApi.getUser())?.region === 'US' ? 'US' : 'EU';

    const accessToken = await client.getTokenSilently();

    const { signedUri, imageUri } = await requestSignedUpload(
      accessToken,
      region.toLowerCase() as 'eu' | 'us',
    );

    await uploadFileToSignedUri(signedUri, file);
    return imageUri;
  }
}
